import { takeLatest } from "redux-saga/effects";
import { apis } from "../../config/APIs";
import { sagaFunctions } from "../../utils";
import {
  Trips,
  TripsComments,
  TripsAddComments,
  TripsHistory,
  TripsApprove,
  TripsReject,
  UserTrips,
  UserTripsSubmit,
  AddUserTrip,
  UserTripFields,
  TripsShow,
  TripsClose,
  TripDetailsPDF,
  UserReportLinkTrip,
  AttachTripFile,
  DownloadTripAttachments,
  RecallTrip,
} from "./trips";

function getTrips(req) {
  return sagaFunctions(Trips, "get", apis.trips, req.payload, {
    skipSuccessMessage: true,
  })();
}

function downloadTripPDF(req) {
  return sagaFunctions(
    TripDetailsPDF,
    "get",
    apis.export_trip_details,
    req.payload,
    { skipSuccessMessage: true },
  )();
}
function attachFilesToTrip(req) {
  return sagaFunctions(
    AttachTripFile,
    "post",
    apis.attach_trip_file,
    req.payload,
    {
      "Content-Type": "application/json;charset=UTF-8",
    },
  )();
}

function download_trip_attachments(req) {
  return sagaFunctions(
    DownloadTripAttachments,
    "get",
    apis.download_trip_attachments,
    req.payload,
  )();
}
function tripsClose(req) {
  return sagaFunctions(TripsClose, "post", apis.tripClose, req.payload, {
    "Content-Type": "application/json;charset=UTF-8",
  })();
}

function getTripsComments(req) {
  return sagaFunctions(
    TripsComments,
    "get",
    req.otherParams?.is_admin ? apis.tripsComments : apis.userTripsComments,
    req.payload,
    {
      headers: {
        "Content-Type": "multipart/formdata",
      },
      skipSuccessMessage: true,
    },
  )();
}

function getTripsAddComments(req) {
  return sagaFunctions(
    TripsAddComments,
    "post",
    req.otherParams?.is_admin ? apis.tripsComments : apis.userTripsComments,
    req.payload,
    {
      headers: {
        "Content-Type": "multipart/formdata",
      },
      skipSuccessMessage: true,
    },
  )();
}

function getTripsHistory(req) {
  return sagaFunctions(
    TripsHistory,
    "get",
    req.otherParams?.is_admin ? apis.tripsHistory : apis.userTripsHistory,
    req.payload,
    {
      headers: {
        "Content-Type": "multipart/formdata",
      },
      skipSuccessMessage: true,
    },
  )();
}

function getTripsApprove(req) {
  return sagaFunctions(TripsApprove, "post", apis.tripsApprove, req.payload, {
    "Content-Type": "multipart/formdata",
  })();
}

function getTripsReject(req) {
  return sagaFunctions(
    TripsReject,
    "post",
    req?.others?.isDelete ? apis.tripsDelete : apis.tripsReject,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

function getUserTrips(req) {
  return sagaFunctions(UserTrips, "get", apis.userTrips, req.payload, {
    skipSuccessMessage: true,
  })();
}

function getUserTripsSubmit(req) {
  return sagaFunctions(
    UserTripsSubmit,
    "post",
    apis.userTripsSubmit,
    req.payload,
    {
      headers: {
        "Content-Type": "multipart/formdata",
      },
      skipSuccessMessage: true,
    },
  )();
}

function tripsShow(req) {
  return sagaFunctions(TripsShow, "get", apis.tripsShow, req.payload, {
    skipSuccessMessage: true,
  })();
}

function getAddUserTrip(req) {
  return sagaFunctions(
    AddUserTrip,
    "post",
    req.payload.id ? apis.update_trip : apis.userTrips,
    req.payload,
    { skipSuccessMessage: true },
  )();
}

function getUserReportLinkTrip(req) {
  return sagaFunctions(
    UserReportLinkTrip,
    "post",
    apis.userTripLinkReport,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

function recallTrip(req) {
  let isCancel = req.payload.isCancel;
  delete req.payload.isCancel;
  return sagaFunctions(
    RecallTrip,
    "post",
    isCancel ? apis.userTripCancel : apis.userTripRecall,
    req.payload,
  )();
}

function getUserTripFields(req) {
  return sagaFunctions(
    UserTripFields,
    "get",
    apis.userTripFields,
    req.payload,
    {
      headers: {
        "Content-Type": "multipart/formdata",
      },
      skipSuccessMessage: true,
    },
  )();
}

export function* tripsWatcher() {
  yield takeLatest(Trips.REQUEST, getTrips);
  yield takeLatest(DownloadTripAttachments.REQUEST, download_trip_attachments);
  yield takeLatest(AttachTripFile.REQUEST, attachFilesToTrip);
  yield takeLatest(TripsComments.REQUEST, getTripsComments);
  yield takeLatest(TripsAddComments.REQUEST, getTripsAddComments);
  yield takeLatest(TripsHistory.REQUEST, getTripsHistory);
  yield takeLatest(TripsApprove.REQUEST, getTripsApprove);
  yield takeLatest(TripsReject.REQUEST, getTripsReject);

  yield takeLatest(UserTrips.REQUEST, getUserTrips);
  yield takeLatest(UserTripsSubmit.REQUEST, getUserTripsSubmit);
  yield takeLatest(AddUserTrip.REQUEST, getAddUserTrip);
  yield takeLatest(UserTripFields.REQUEST, getUserTripFields);
  yield takeLatest(UserReportLinkTrip.REQUEST, getUserReportLinkTrip);
  yield takeLatest(TripsShow.REQUEST, tripsShow);
  yield takeLatest(TripsClose.REQUEST, tripsClose);
  yield takeLatest(RecallTrip.REQUEST, recallTrip);
  yield takeLatest(TripDetailsPDF.REQUEST, downloadTripPDF);
}
